import React from 'react'
import './components/navigationbar.css'
import { Tab, Tabs } from 'react-bootstrap'

export const ExecutiveAction = () => (
  <>
    <div className="hero">
      <h1>Executive Action</h1>
    </div>
    <section className="hero is-fullheight mb-5">
      <div className="columns">
        <div className="column is-one-fifth fadeLeftMini"></div>
        <div className="column is-vcentered">
          <Tabs defaultActiveKey="first" id="uncontrolled-tab-example">
            <Tab eventKey="first" title="Current Year (Post-Investment)">
              <p>
                <h6>Months 1-3 (Investment Execution):</h6>
                <li>
                Secure £75,000-£125,000 investment funding to scale operations 
                and fulfill established partnership contracts.
                </li>
                <li>
                Purchase additional equipment, vehicles, and supplies to expand 
                service capacity for partnership fulfillment.
                </li>
                <li>
                Hire and train additional staff to handle increased workload 
                from retail partnership contract execution.
                </li>
                <li>
                Finalize fuel retailer partnership agreement and commence 
                service delivery preparations.
                </li>
                <li>
                Implement quality control systems to ensure consistent service 
                delivery across multiple B2B contracts.
                </li>
              </p>
              <p>
                <h6>Months 4-6 (Partnership Activation):</h6>
                <li>
                Begin full execution of major retail partnership contract 
                with established service locations and schedules.
                </li>
                <li>
                Launch fuel retailer partnership services across agreed 
                locations and service parameters.
                </li>
                <li>
                Monitor service quality and customer satisfaction through 
                partnership feedback mechanisms.
                </li>
                <li>
                Optimize operational efficiency based on real partnership 
                experience and requirements.
                </li>
                <li>
                Build revenue stream from existing partnerships while maintaining 
                service quality standards.
                </li>
              </p>
              <p>
                <h6>Months 7-9 (Operational Scaling):</h6>
                <li>
                Analyze performance data from active partnerships to identify 
                optimization opportunities.
                </li>
                <li>
                Explore expansion opportunities within existing partnership 
                agreements (additional locations/services).
                </li>
                <li>
                Develop additional automotive dealer relationships based on 
                proven service delivery track record.
                </li>
                <li>
                Maintain cash flow positive operations through partnership 
                contract fulfillment.
                </li>
              </p>
              <p>
                <h6>Months 10-12 (Growth Foundation):</h6>
                <li>
                Achieve break-even operations through established partnership 
                revenue streams.
                </li>
                <li>
                Evaluate partnership contract renewals and expansion terms.
                </li>
                <li>
                Assess market opportunities for additional B2B partnerships 
                based on proven operational capabilities.
                </li>
                <li>
                Document operational procedures and best practices for 
                future scaling opportunities.
                </li>
              </p>
            </Tab>
            <Tab eventKey="fifth" title="3-Year Growth Plan (Post-Investment)">
              <p>
                <h6>Year 1 (2025 - Foundation):</h6>
                <li>
                Execute established retail and fuel retailer partnerships 
                generating £50,000-£80,000 revenue with investment funding.
                </li>
                <li>
                Achieve operational break-even within 12-18 months through 
                partnership contract fulfillment.
                </li>
                <li>
                Build operational capacity to handle multiple B2B contracts 
                simultaneously with consistent quality.
                </li>
                <li>
                Develop additional automotive dealer relationships based on 
                proven partnership performance.
                </li>
                <li>
                Establish documented operational procedures and quality 
                control systems for sustainable growth.
                </li>
              </p>
              <p>
                <h6>Year 2 (2026 - Expansion):</h6>
                <li>
                Target £120,000-£180,000 revenue through partnership 
                expansion and additional B2B contract development.
                </li>
                <li>
                Explore geographic expansion within Surrey & Greater London 
                based on partnership requirements.
                </li>
                <li>
                Develop service portfolio enhancements (advanced ceramic 
                coatings, specialized treatments) for premium positioning.
                </li>
                <li>
                Build relationships with additional commercial partners 
                based on proven service delivery track record.
                </li>
                <li>
                Maintain positive cash flow while investing in sustainable 
                growth opportunities.
                </li>
              </p>
              <p>
                <h6>Year 3 (2027 - Optimization):</h6>
                <li>
                Target £200,000-£300,000 revenue through optimized operations 
                and expanded partnership network.
                </li>
                <li>
                Evaluate franchise or licensing opportunities based on proven 
                operational model and financial performance.
                </li>
                <li>
                Implement technology solutions for enhanced operational 
                efficiency and customer experience.
                </li>
                <li>
                Assess strategic acquisition opportunities within automotive 
                care sector for growth acceleration.
                </li>
                <li>
                Conduct comprehensive business review to determine optimal 
                growth strategy for Years 4-5.
                </li>
              </p>
            </Tab>
            <Tab eventKey="tenth" title="Long-term Vision (5-10 Years)">
              <p>
                <h6>Years 4-5 (Strategic Development):</h6>
                <li>
                Evaluate franchise or licensing model development based on 
                proven operational performance and financial stability.
                </li>
                <li>
                Assess geographic expansion opportunities within UK market 
                based on demonstrated partnership success.
                </li>
                <li>
                Explore strategic partnerships or acquisition opportunities 
                to accelerate growth while maintaining service quality.
                </li>
                <li>
                Develop advanced service offerings and technology integration 
                to maintain competitive differentiation.
                </li>
                <li>
                Target sustainable £500,000+ annual revenue through optimized 
                operations and expanded market presence.
                </li>
              </p>
              <p>
                <h6>Years 6-8 (Market Leadership):</h6>
                <li>
                Establish market leadership position in eco-friendly mobile 
                automotive care within operational regions.
                </li>
                <li>
                Consider selective franchise development or licensing agreements 
                based on proven business model and financial performance.
                </li>
                <li>
                Evaluate international expansion opportunities through 
                partnerships or strategic alliances.
                </li>
                <li>
                Implement advanced technology solutions for operational 
                efficiency and enhanced customer experience.
                </li>
                <li>
                Build comprehensive automotive care ecosystem through 
                strategic service portfolio expansion.
                </li>
              </p>
              <p>
                <h6>Years 9-10 (Strategic Options):</h6>
                <li>
                Evaluate exit strategies including trade sale, management 
                buyout, or strategic partnership opportunities.
                </li>
                <li>
                Assess succession planning and business continuity options 
                for long-term sustainability.
                </li>
                <li>
                Consider diversification into complementary automotive or 
                environmental services based on market opportunities.
                </li>
                <li>
                Focus on maximizing business value through proven operational 
                excellence and market positioning.
                </li>
                <li>
                Maintain leadership position in eco-conscious automotive care 
                through continuous innovation and adaptation.
                </li>
              </p>
            </Tab>
          </Tabs>
        </div>
        <div className="column is-one-fifth fadeLeftMini"></div>
      </div>
    </section>
  </>
)
